import React from 'react'

const CriminalPartiesRow = ({meta}) => (
    <tr>
        <td>{meta.party_name}</td>
        <td>{meta.party_role}</td>
        <td>{meta.court_code}</td>
        <td className="ir-search-no-wrap"><a href={"/filings/" + meta.case_uuid} target="_blank">{meta.case_no}</a></td>
        <td>{meta.date_filed}</td>
        <td>{meta.date_closed}</td>
    </tr>
)

export default CriminalPartiesRow



/** WEBPACK FOOTER **
 ** ./src/components/search/results/CriminalPartiesRow.js
 **/